var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.media.type === 'YouTube')?_c('div',{staticClass:"media",domProps:{"innerHTML":_vm._s(_vm.media.embed)}}):_c('div',{staticClass:"media"},[_vm._v("\n  Media type "+_vm._s(_vm.media.type)+" not supported yet.\n")])}
var staticRenderFns = []

export { render, staticRenderFns }